




























































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import IDoctor from '@/interfaces/doctor';
import { IRule } from '@/interfaces/rules-engine';
import RuleModel from '@/models/rule-model';
import { getTeamsByClient } from '@/services/teams';
import {
  REFERENCE_TYPE_CLIENT,
  REFERENCE_TYPE_DOCTOR,
  REFERENCE_TYPE_PATIENT,
  REFERENCE_TYPE_TEAM
} from '@/settings/consts/rules-engine';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: { UiAutocompleClientsSubsidiaries, UiSelectDoctor },
})
export default class RulesEngineOverridesFilterList extends BaseComponent {
  @Prop()
  public rule: IRule;

  public filter: any = {
    rule: {},
    referenceType: null,
    clientUnit: null,
    doctor: null,
    team: null,
  };

  public selectedClient: any = {};

  public referencesTypesList: any[] = [
    {
      id: REFERENCE_TYPE_CLIENT,
      label: 'Unidade',
    },
    {
      id: REFERENCE_TYPE_TEAM,
      label: 'Time',
    },
    {
      id: REFERENCE_TYPE_DOCTOR,
      label: 'Médico',
    },
    {
      id: REFERENCE_TYPE_PATIENT,
      label: 'Paciente',
    },
  ];

  public referencesTypes: any = {
    client: REFERENCE_TYPE_CLIENT,
    team: REFERENCE_TYPE_TEAM,
    doctor: REFERENCE_TYPE_DOCTOR,
  };

  public rules: any[] = [];
  public doctors: IDoctor[] = [];
  public teams: any[] = [];
  public rulesLoading: boolean = false;
  public doctorsLoading: boolean = false;
  public teamsLoading: boolean = false;

  @Watch('rule')
  public onRuleChange(val: RuleModel): void {
    if (!!val) {
      this.filter.rule = val;
      this.onFilter();
    }
  }

  public mounted(): void {
    this.onFilter();
  }

  public onChangeClientTeam(): void {
    if (!this.selectedClient || !this.selectedClient.id) {
      return;
    }
    this.getTeams(this.selectedClient.id);
  }

  public onChangeFilterReference(): void {
    this.filter.clientUnit = null;
    this.filter.doctor = null;
    this.filter.team = null;
    this.onFilter();
  }

  public onFilter(): void {
    this.$emit('filter', this.filter);
  }

  private getTeams(clientUnitId: string): void {
    this.teams = [];
    this.teamsLoading = true;

    if (!clientUnitId) {
      return;
    }

    getTeamsByClient(clientUnitId).subscribe(
      (data) => {
        this.teams = data;
        this.teamsLoading = false;
      },
      () => {
        this.teamsLoading = false;
      },
    );
  }
}
